export default "__VITE_ASSET__DibYVzzm__"